/**
 * @file The Start component.
 * @author Heino Lenting
*/
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesService } from '../../routes.service';
var StartComponent = /** @class */ (function () {
    function StartComponent(router, routesService) {
        this.router = router;
        this.routesService = routesService;
    }
    StartComponent.prototype.ngOnInit = function () {
        this.router.resetConfig(this.routesService.routes);
        // Rewrite deep links to not-so-deep links because this works in case of (non)-existing
        // entities and sharing a 'new entity link (=/new/) is not an expected use case.
        //
        // 'projectsshifts/tasks/E1Z21' -> 'projectsshifts/tasks'
        // 'projectsshifts/tasks/new/K_-1' => 'projectsshifts/tasks'
        var currentUrl = this.router.url.startsWith('/') ? this.router.url.substr(1) : this.router.url;
        var rewritedUrl = currentUrl.split('/').slice(0, 2).join('/');
        this.router.navigateByUrl(rewritedUrl);
    };
    return StartComponent;
}());
export { StartComponent };
